import { IMiddleware, Middleware, StopAction } from '@tencent/workbench';
import type { IStopAction } from '@tencent/workbench';
import { i18n } from '@src/slide/application/service/edit-extension/edit-extension-export';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';

/**
 * 导出权限中间件，用于workbench按钮的禁用；
 * 没有导出权限返回true, 并且不会执行后面注册的回调函数；
 */
@Middleware()
export class ExportNoPermissionMiddleware implements IMiddleware {
    public use(@StopAction() stop: IStopAction) {
        if (!SlideDataServices.PrivilegeManager()?.exportable) {
            stop();
            return i18n.t('没有可导出权限，请联系文档所有者');
        }
    }
}
